<template>
  <el-form
    :model="from"
    status-icon
    :rules="rules"
    ref="from"
    label-width="120px"
    class="demo-from"
  >
    <el-form-item :label="$t('admin.password')" prop="pass">
      <el-input type="password" v-model="from.pass" autocomplete="off"></el-input>
    </el-form-item>
    <el-form-item :label="$t('admin.confirm')" prop="checkPass">
      <el-input type="password" v-model="from.checkPass" autocomplete="off"></el-input>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="submitForm('from')">{{ $t('admin.submit') }}</el-button>
    </el-form-item>
    <div class="validateerrors" style="padding-left:40px">
      <li v-if="passwordPolicy.minCharacter">
      <span v-if="from.pass.length<passwordPolicy.minCharacter" style="color:red">{{"Min. Password Length "+passwordPolicy.minCharacter}}</span>
      <span v-else style="color:green">{{"Min. Password Length "+passwordPolicy.minCharacter}}</span>
      </li>
      <li v-if="passwordPolicy.requiresLowerCaseLetters">
      <span v-if="!new RegExp(`[${this.lowerReg}]`).test(from.pass)"  style="color:red">{{"Min. One LowerCase Character "}}</span>
       <span v-else style="color:green">{{"Min. One LowerCase Character "}}</span>
      </li>
       <li v-if="passwordPolicy.requiresUpperCaseLetters">
      <span v-if="!new RegExp(`[${this.upperReg}]`).test(from.pass)" style="color:red">{{"Min. One UpperCase Character "}}</span>
        <span v-else style="color:green">{{"Min. One UpperCase Character "}}</span>
       </li>
       <li v-if="passwordPolicy.requiresSpecialCharacters">
       <span v-if="!new RegExp(`[${this.specialReg}]`).test(from.pass)" style="color:red">{{"Min. One Special Character "}}</span>
        <span v-else style="color:green">{{"Min. One Special Character "}}</span>
       </li>
        <li v-if="passwordPolicy.requiresNumbers">
       <span v-if="!new RegExp(`[${this.numberReg}]`).test(from.pass)" style="color:red">{{"Min. One Numeric Character "}}</span>
        <span v-else style="color:green">{{"Min. One Numeric Character "}}</span>
        </li>
 </div>
  </el-form>
</template>
<script>
import axios from "axios";
import { mapActions } from "vuex";
import preferences from "../util/preferences"
import passwordCheck from "../util/passwordCheck"
export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("Please input the password"));
      } 
      if (this.from.checkPass !== "") {
          this.$refs.from.validateField("checkPass");
          callback()
      }

      else {
      callback()
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("Please input the password again"));
      } else if (value !== this.from.pass) {
        callback(new Error("Two inputs don't match!"));
      } else {
        callback();
      }
    };
    return {
      passwordPolicy:preferences().passwordPolicy,
      upperReg:passwordCheck.upper,
      lowerReg:passwordCheck.lower,
      specialReg:passwordCheck.special,
      numberReg:passwordCheck.number,
      from: {
        pass: "",
        checkPass: "",
      },
      rules: {
        pass: [
          { validator: validatePass, trigger: "change" },
          ],
        checkPass: [{ validator: validatePass2, trigger: "blur" }]
      }
    };
  },
  methods: {
    ...mapActions('account', ['logout']),
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          var body = {
            password: this.from.pass
          };
          axios.post(`${process.env.VUE_APP_APIURL}/me/password`, body)
            .then(() => {
               this.logout()
            })
            .catch(err => {
              this.$message.error(err.response.data.message);
            })
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style scoped>
.validateerrors{
  display:flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
}
.validateerrors li{
  margin-top:10px;
  width:45%

}
</style>